import transformSize from './transform-size'
import Logger from '../appl/logger'

function initPrebid(prebidConfig: PbjsConfig, prebidBidderSettings?: PbjsBidderSettings) {
    window.pbjs = window.pbjs || { que: [] }
    window.pbjs.que.push(() => {
        window.pbjs.setConfig(prebidConfig)
        if (prebidBidderSettings) window.pbjs.bidderSettings = prebidBidderSettings
    })
}

function toAdUnit(slot: SlotDefinition): PbjsAdUnit {
    return {
        code: slot.id,
        mediaTypes: { banner: { sizes: transformSize(slot.size) } },
        bids: slot.prebid,
    }
}

export default class PrebidBidderService implements BidderService {
    public static readonly NAME = 'Prebid.js'
    public readonly name = PrebidBidderService.NAME
    public readonly adUnits: Dict<PbjsAdUnit> = {}

    constructor(config: HeaderBiddingConfig) {
        if (!config.prebidConfig) {
            throw new Error('prebidConfig が定義されていません')
        }
        initPrebid(config.prebidConfig, config.prebidBidderSettings)
    }

    public addSlot(...slots: SlotDefinition[]) {
        slots.filter(slot => slot.prebid).forEach(slot => this.addPrebidSlot(slot))
    }

    /**
     * @override
     */
    public requestBids(slots: SlotDefinition[], callback: Command) {
        const adUnits = this.getAdUnits(slots)
        if (adUnits.length < 1) {
            Logger.warn('Prebid.js 広告枠 がないため Prebid.js での入札は行いません', slots)
            return
        }

        Logger.debug('Prebid.js 広告枠の入札を開始します', adUnits)
        Logger.time('Prebid.js 広告入札リクエスト')
        window.pbjs.que.push(() => {
            window.pbjs.addAdUnits(adUnits)
            window.pbjs.requestBids({
                bidsBackHandler: () => {
                    Logger.timeEnd('Prebid.js 広告入札リクエスト')
                    callback()
                },
            })
        })
    }

    public preRenderAds(_slots: SlotDefinition[]) {
        window.pbjs.que.push(() => {
            window.pbjs.setTargetingForGPTAsync()
        })
    }

    private addPrebidSlot(slot: SlotDefinition) {
        this.adUnits[slot.id] = toAdUnit(slot)
        Logger.debug(`Prebid.js 広告枠 [${slot.id}]`, this.adUnits[slot.id])
    }

    private getAdUnits(slots: SlotDefinition[]) {
        return slots
            .map(slot => slot.id)
            .filter(id => id in this.adUnits)
            .map(id => this.adUnits[id])
    }
}
